<template>
  <div>

    <div v-if="showFreight" class="coupon-div">
      <div class="am-radio">
        <input type="radio" value="41106" v-model="freightType" id="pac" name="freight_type">
        <label for="pac">PAC</label>
      </div>
      <div class="am-radio">
        <input type="radio" class="am-radio" value="40010" v-model="freightType" id="sedex" name="freight_type">
        <label for="sedex">SEDEX</label>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="input-group">
            <input
                v-model="zipCode"
                id="freight"
                type="text"
                v-mask="'#####-###'"
                class="form-control text-uppercase"
                placeholder="xxxx-xxx">
            <span class="input-group-btn">
              <button id="btn-calculate-freight"
                      @click="calculateFreight()"
                      class="btn btn-tagsell-yellow border-6">
                  Calcular frete
                    <i v-if="loadingFreight" class="fa fa-circle-o-notch fa-spin"></i>
              </button>
          </span>
          </div>
        </div>
      </div>
    </div>

    <div class="coupon-div">
      <p>
        Insira seu cupom de desconto
      </p>

      <div class="row">
        <div class="col-xs-12">
          <div class="input-group">
            <input
                v-model="code"
                id="coupon"
                type="text"
                class="form-control coupon text-uppercase"
                placeholder="número do cupom">
            <span class="input-group-btn">
              <button id="btn-add-coupon"
                      @click="addCoupon()"
                      class="btn btn-tagsell-yellow border-6">
                  Adicionar
              </button>
          </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="coupon" class="coupon-div panel panel-default">
      <p>Cupom</p>
      <div class="row">
        <div class="col-md-6">
          Código: {{ coupon }}
        </div>
        <div class="col-md-5 text-center">
          Valor: R$ {{couponValueFormatted}}
        </div>
        <div class="col-md-1">
          <a href="#" class="coupon-remove" @click.prevent="removeCoupon()">
            <i class="s7-close-circle"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'freight-template',

    created() {
      this.$root.$on('removeItemWithFreight', () => this.productsWithFreight -= 1);
      this.$root.$on('propagateType', (payload) => {
        if (payload == 5 || payload == 6) {
          this.productsWithFreight += 1;
        }
      });
      const vm = this;
      this.$root.$on('updateCoupon', _.debounce(function () {
        const coupon = localStorage.getItem('coupon');
        if (coupon && vm.coupon === null) {
          vm.code = coupon;
          vm.addCoupon();
        }
      }, 500));
    },

    mounted() {
      this.$root.$on('currentTotal', (total) => this.currentTotal = total);
      this.$root.$on('removeCoupon', () => this.removeCoupon());
      this.$root.$on('updateFreightFromItem', () => this.calculateFreight(false));
    },

    watch: {
      freightTotal(total) {
        if (total) {
          this.$root.$emit('updateFreight', {
            total: total,
            deadline: this.deadline,
            zipCode: this.zipCode,
            freightType: this.freightType,
          })
        }
      },

      freightType() {
        this.calculateFreight();
      }
    },

    computed: {
      cart: {
        get() {
          return this.$store.getters['getCart'];
        },
        set(cart) {
          this.$store.commit('SET_CART', cart);
        }
      },
      showFreight() {
        return this.productsWithFreight > 0;
      }
    },

    data: function () {
      return {
        coupon: null,
        couponValue: 0.00,
        couponValueFormatted: 0.00,
        code: null,
        currentTotal: 0.00,
        zipCode: undefined,
        freightTotal: 0,
        loadingFreight: false,
        freightType: 41106,
        productsWithFreight: 0,
        deadline: 0,
      };
    },

    methods: {
      calculateFreight(showNotification = true) {
        // 41106 PAC
        // 40010 SEDEX
        if ((this.zipCode && this.zipCode.length < 9) && showNotification) {
          return this.$root.gritter('Atenção!', 'Preencha seu CEP corretamente.', 'danger', 2000);
        }

        if (this.zipCode && this.zipCode.length === 9) {
          this.loadingFreight = true;
          const token = $('meta[name="csrf-token"]').attr('content');

          axios.post(`/ajax/store/calculate/freight/${this.zipCode}/${this.freightType}`, {
            cart: this.cart,
          }, {
            _token: token,
          })
            .then((response) => {
              const data = response.data;
              this.$root.gritter('Frete', data.message, data.type, 2000);

              if (!!data.total) {
                this.freightTotal = data.total;
                this.deadline = data.deadline;
              }
            }).finally(() => this.loadingFreight = false)
        }
      },

      addCoupon() {
        if (this.isEmpty(this.code)) {
          this.$root.gritter('Atenção!', 'Preencha o cupom para adicionar à compra.', 'danger');
          return;
        }

        if (this.coupon == this.code) {
          this.$root.gritter('Erro!', 'Cupom já adicionado.', 'danger');
          return;
        }

        this.fetchCoupon();
      },

      fetchCoupon() {
        axios.get(`/loja/ajax/coupon/${encodeURIComponent(this.code)}`).then((response) => {
          let message = response.data.message;
          let status = response.data.status;
          localStorage.removeItem('coupon');

          if (status == 'error') {
            this.$root.gritter('Erro ao adicionar cupom', message, 'danger');
            return;
          }

          this.$root.$emit('getCurrentTotal');

          let total = +response.data.total;

          if (total > this.currentTotal) {
            let errorMessage = 'Valor do desconto do cupom maior que valor total dos itens.';
            this.$root.gritter('Valor inválido!', errorMessage, 'danger');
            return;
          }

          this.coupon = this.code;
          this.couponValue = total;
          this.couponValueFormatted = message;

          this.updateDiscount();

          this.$root.gritter('Desconto calculado!', `Valor do desconto é de: R$ ${message}`, 'success');
          localStorage.setItem('coupon', this.coupon);

        }).catch((error) => {
          if (error.response.status === 401) {
            this.$root.gritter('Cadastre-se!', 'Para adicionar um cupom de desconto é necessário estar cadastrado.', 'info');
          } else {
            this.$root.gritter('Erro!', 'Não foi possível adicionar ao carrinho.', 'danger');
          }
        });
      },

      updateDiscount() {
        this.$root.$emit('updateDiscount', {
          value: this.couponValue,
          coupon: this.coupon,
        });
      },

      removeCoupon() {
        this.coupon = null;
        this.couponValue = 0.00;
        this.couponValueFormatted = null;
        localStorage.removeItem('coupon');

        this.updateDiscount();

        this.$root.gritter('Cupom removido!', 'O cupom de desconto foi removido', 'info');
      },

      isEmpty(value) {
        return value === null || value === 0 || value === '' || value === undefined;
      },
    },
  };
</script>

<style scoped>
  .am-checkbox, .am-radio {
    display: inline-block;
    margin: 0 10px 0 0;
  }

  .coupon-div {
    font-family: 'Montserrat';
    font-weight: 300;
    border: 1px solid #DFDFE0;
    padding: 30px 50px 30px 30px;
  }

  .coupon-div .panel.panel-default {
    margin-top: 20px;
    margin-bottom: 0;
    background-color: #E0E0E0;
    border: 0;
    border-radius: 0;
    padding: 10px;
    font-size: 13px;
  }

  ::-webkit-input-placeholder {
    text-transform: lowercase;
  }

  .coupon-remove {
    color: #ED1763;
    text-decoration: none;
    font-size: 25px;
    display: block;
  }

</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/Freight.vue